<template>
    <div class="finance-detail-wrap">
      <!-- 筛选区域 -->
      <div class="filter-card">
        <div class="search-form">
          <el-form :model="query" inline>
            <el-form-item label="交易类型">
              <el-select v-model="query.type" clearable placeholder="全部" style="width: 140px">
                <el-option label="充值(P)" value="P" />
                <el-option label="API扣费(A)" value="A" />
                <el-option label="产品扣费(C)" value="C" />
              </el-select>
            </el-form-item>
  
            <el-form-item label="订单号">
              <el-input
                v-model="query.orderNo"
                placeholder="输入订单号搜索"
                clearable
                @keyup.enter="handleSearch"
              />
            </el-form-item>
  
            <el-form-item label="日期范围">
              <el-date-picker
                v-model="query.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="YYYY-MM-DD"
                :shortcuts="dateShortcuts"
                style="width: 260px"
              />
            </el-form-item>
  
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="resetQuery">重置</el-button>
              <el-button type="success" :disabled="selectedRows.length === 0" @click="batchExport">
                批量导出明细
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
  
      <!-- 当前筛选汇总统计 + 接口返回numdata月度/日统计 -->
      <div class="stat-row">
        <div class="stat-item">
          <span class="stat-label">本月累计额度：</span>
          <span class="stat-value green">¥{{ numData.mounth }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">今日额度：</span>
          <span class="stat-value green">¥{{ numData.day }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">筛选区间总增加：</span>
          <span class="stat-value green">+¥{{ summary.totalAdd }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">筛选区间总扣减：</span>
          <span class="stat-value red">-¥{{ summary.totalSub }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">区间净变动：</span>
          <span :class="['stat-value', summary.net >= 0 ? 'green' : 'red']">
            {{ summary.net >= 0 ? "+" : "" }}¥{{ summary.net }}
          </span>
        </div>
      </div>
  
      <!-- 明细表格 -->
      <div class="table-wrap">
        <el-table
          :data="tableList"
          border
          stripe
          class="finance-table"
          ref="tableRef"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column label="流水ID" prop="id" align="center" width="120" />
          <el-table-column label="关联订单号" prop="orderNo" align="center" min-width="220" show-overflow-tooltip />
          <el-table-column label="交易类型" align="center" width="140">
            <template #default="scope">
              <div>
                <el-tag :type="getFlowTag(scope.row)" size="small">
                  {{ getFlowTypeName(scope.row) }}
                </el-tag>
                <div style="font-size:11px;color:#888;margin-top:2px">原始:{{ scope.row.type }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="变动金额" align="center" width="130">
            <template #default="scope">
              <span :class="getAmountClass(scope.row)">
                {{ getAmountPrefix(scope.row) }}¥{{ scope.row.change_amount }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="变动前可用额度" prop="history_available" align="center" width="140" />
          <el-table-column label="变动后可用额度" prop="change_available" align="center" width="140" />
          <el-table-column label="交易时间" prop="create_time" align="center" width="180">
            <template #default="scope">
              {{ formatTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="110">
            <template #default="scope">
              <el-button type="primary" text @click="viewDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <!-- 分页 -->
      <div class="page-bar">
        <div style="margin-right: 16px; color: #666" v-if="selectedRows.length > 0">
          已选中
          <span style="color: #2b5bff; font-weight: bold">{{ selectedRows.length }}</span>
          条
        </div>
        <el-pagination
          v-model:current-page="page.page"
          v-model:page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSearch"
          @current-change="handleSearch"
        />
      </div>
  
      <!-- 流水详情弹窗 -->
      <el-dialog v-model="dialogVisible" title="财务流水详情" width="560px">
        <div class="detail-content" v-if="currentRow">
          <div class="detail-row">
            <label>流水ID：</label>
            <span>{{ currentRow.id }}</span>
          </div>
          <div class="detail-row">
            <label>订单号：</label>
            <span>{{ currentRow.orderNo || "-" }}</span>
          </div>
          <div class="detail-row">
            <label>业务原始类型：</label>
            <span>{{ getOriginTypeName(currentRow.type) }}（{{ currentRow.type }}）</span>
          </div>
          <div class="detail-row">
            <label>实际流向：</label>
            <el-tag :type="getFlowTag(currentRow)" size="small">{{ getFlowTypeName(currentRow) }}</el-tag>
          </div>
          <div class="detail-row">
            <label>变动金额：</label>
            <span :class="getAmountClass(currentRow)">
              {{ getAmountPrefix(currentRow) }}¥{{ currentRow.change_amount }}
            </span>
          </div>
          <div class="detail-row">
            <label>变动前可用额度：</label>
            <span>¥{{ currentRow.history_available }}</span>
          </div>
          <div class="detail-row">
            <label>变动后可用额度：</label>
            <span>¥{{ currentRow.change_available }}</span>
          </div>
          <div class="detail-row">
            <label>交易时间：</label>
            <span>{{ formatTime(currentRow.create_time) }}</span>
          </div>
        </div>
        <template #footer>
          <el-button @click="dialogVisible = false">关闭</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from "vue";
  import { ElMessage } from "element-plus";
  import { getWalletLogList } from "@/api/api";
  
  const tableRef = ref(null);
  const selectedRows = ref([]);
  const dialogVisible = ref(false);
  const currentRow = ref(null);
  const tableList = ref([]);
  
  // numdata 接口返回月度、今日统计
  const numData = reactive({
    mounth: 0,
    day: 0,
  });
  
  // 查询条件
  const query = reactive({
    type: "",
    orderNo: "",
    dateRange: [],
  });
  
  // 分页参数
  const page = reactive({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  
  // 汇总统计：基于前后额度差计算，不再依赖type
  const summary = reactive({
    totalAdd: 0,
    totalSub: 0,
    net: 0,
  });
  
  // 日期快捷项
  const dateShortcuts = [
    {
      text: "今日",
      value: () => {
        const now = new Date();
        return [new Date(now.setHours(0, 0, 0, 0)), new Date()];
      },
    },
    {
      text: "本月",
      value: () => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        start.setHours(0, 0, 0, 0);
        return [start, new Date()];
      },
    },
  ];
  
  // 原始业务类型文本
  const getOriginTypeName = (val) => {
    const map = {
      P: "充值",
      A: "API调用扣费",
      C: "平台产品扣费",
    };
    return map[val] || val;
  };
  
  /**
   * 核心逻辑：对比 history_available 变动前 / change_available 变动后
   * true → 额度增加（充值/退款）；false → 扣减消耗
   */
  const isIncreaseFlow = (row) => {
    const before = Number(row.history_available || 0);
    const after = Number(row.change_available || 0);
    return after > before;
  };
  
  // 显示名称：区分【充值/退款】
  const getFlowTypeName = (row) => {
    const increase = isIncreaseFlow(row);
    if (increase) {
      // 额度增加，原始P一般充值，其他为退款
      return row.type === "P" ? "充值" : "退款";
    } else {
      return "扣费消耗";
    }
  };
  
  const getFlowTag = (row) => {
    return isIncreaseFlow(row) ? "success" : "danger";
  };
  
  const getAmountPrefix = (row) => {
    return isIncreaseFlow(row) ? "+" : "-";
  };
  const getAmountClass = (row) => {
    return isIncreaseFlow(row) ? "text-green" : "text-red";
  };
  
  // ISO时间格式化
  const formatTime = (isoStr) => {
    if (!isoStr) return "-";
    const date = new Date(isoStr);
    return date.toLocaleString("zh-CN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };
  
  // 选中行
  const handleSelectionChange = (val) => {
    selectedRows.value = val;
  };
  
  // 批量导出
  const batchExport = () => {
    if (!selectedRows.value.length) {
      ElMessage.warning("请勾选流水记录");
      return;
    }
    const ids = selectedRows.value.map((i) => i.id);
    console.log("待导出流水id集合", ids);
    ElMessage.success(`已选择${ids.length}条记录，准备导出`);
  };
  
  // 查询列表
  const getList = async () => {
    const params = {
      page: page.page,
      pageSize: page.pageSize,
    };
    if (query.type) params.type = query.type;
    if (query.orderNo) params.orderNo = query.orderNo;
  
    const res = await getWalletLogList(params);
    if (res.code === 200) {
      const data = res.data;
      tableList.value = data.list || [];
      page.total = data.total;
  
      // 赋值接口返回的numdata月度、今日额度
      if (data.numdata) {
        numData.mounth = Number(data.numdata.mounth || 0);
        numData.day = Number(data.numdata.day || 0);
      }
  
      // 通过前后额度差计算真实增加、扣减
      let addTotal = 0;
      let subTotal = 0;
      tableList.value.forEach((item) => {
        const before = Number(item.history_available || 0);
        const after = Number(item.change_available || 0);
        const diff = Math.abs(after - before);
        if (after > before) {
          addTotal += diff;
        } else {
          subTotal += diff;
        }
      });
      summary.totalAdd = addTotal.toFixed(2);
      summary.totalSub = subTotal.toFixed(2);
      summary.net = (addTotal - subTotal).toFixed(2);
    }
  };
  
  // 查询触发
  const handleSearch = () => {
    selectedRows.value = [];
    tableRef.value?.clearSelection();
    getList();
  };
  
  // 重置
  const resetQuery = () => {
    query.type = "";
    query.orderNo = "";
    query.dateRange = [];
    page.page = 1;
    handleSearch();
  };
  
  // 打开详情弹窗
  const viewDetail = (row) => {
    currentRow.value = { ...row };
    dialogVisible.value = true;
  };
  
  onMounted(() => {
    getList();
  });
  </script>
  
  <style lang="scss" scoped>
  .finance-detail-wrap {
    width: 100%;
    min-height: 100vh;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
    background: radial-gradient(1200px 600px at 10% -10%, #e8efff 0%, transparent 60%),
      radial-gradient(900px 500px at 110% 110%, #f0eaff 0%, transparent 55%),
      linear-gradient(180deg, #f7f9ff 0%, #eef2fb 100%);
    display: flex;
    flex-direction: column;
    gap: 20px;
  
    .filter-card {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px 20px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
    }
  
    .stat-row {
      background: #fff;
      border-radius: 16px;
      padding: 16px 24px;
      display: flex;
      gap: 32px;
      flex-wrap: wrap;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
      .stat-item {
        font-size: 15px;
        .stat-label {
          color: #6b7280;
        }
        .stat-value {
          font-weight: 600;
          margin-left: 6px;
          &.green {
            color: #16a34a;
          }
          &.red {
            color: #ef4444;
          }
        }
      }
    }
  
    .table-wrap {
      flex: 1;
      background: #fff;
      border-radius: 16px;
      padding: 16px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
    }
  
    .page-bar {
      width: 100%;
      height: 48px;
      display: flex;
      padding: 10px 0;
      justify-content: flex-end;
      align-items: center;
    }
  
    .text-green {
      color: #16a34a;
      font-weight: 500;
    }
    .text-red {
      color: #ef4444;
      font-weight: 500;
    }
  
    .detail-content {
      .detail-row {
        display: flex;
        padding: 10px 0;
        border-bottom: 1px solid #f0f0f0;
        label {
          flex: 0 0 140px;
          color: #6b7280;
        }
        span {
          flex: 1;
          color: #1f2937;
        }
      }
    }
  }
  
  @media (max-width: 720px) {
    .finance-detail-wrap {
      padding: 12px;
    }
    .stat-row {
      flex-direction: column;
      gap: 12px;
    }
  }
  </style>